export const PRICING_CONSTANTS = {
    costSummaryBase: 'base',
    costSummaryDiscount: 'discount',
    costSummaryDiscountedTotal: 'discountedTotal',
    costSummaryTotal: 'total',
    leaseDays: 'leaseDays',
    area: 'area',
    areaDays: 'areaDays',
    adjustmentCategoryDiscount: 'Discount'
};

export const UNIT_CONSTANTS = {
    percentage: 'percentage'
};

// Replace all occurrences of the key in the formula
export const REPLACE_KEY_IN_FORMULA_REGEX = (key: string) => {
    return new RegExp(`\\b${key}\\b`, 'g');
};

export const AREA_COLUMNS = [PRICING_CONSTANTS.area, PRICING_CONSTANTS.areaDays];

export const CALCULATED_COST_PER_LEASE_COLUMNS = ['costPerDay', 'costPerWeek'];

export const CALCULATED_COST_PER_AREA_COLUMNS = [
    'costPerAreaDay',
    'costPerAreaWeek',
    'costPerAreaMonth',
    'costPerAreaYear'
];

export const CALCULATED_COST_COLUMNS = [...CALCULATED_COST_PER_AREA_COLUMNS, ...CALCULATED_COST_PER_LEASE_COLUMNS];

export const COST_ANALYSIS_COLS = [
    PRICING_CONSTANTS.leaseDays,
    ...CALCULATED_COST_PER_LEASE_COLUMNS,
    PRICING_CONSTANTS.area,
    ...CALCULATED_COST_PER_AREA_COLUMNS
];
// Matches a variable name in the formula, which can be a field name or a custom variable
// A variable name must start with a letter or underscore, followed by letters, digits, or underscores
// This regex is used to find variable names in the formula for evaluation
// Example: "area * costPerAreaDay" will match "area" and "cost
export const FIELD_VARIABLE_MATCHER = /\b[a-zA-Z_][a-zA-Z0-9_]*\b/g;
